import React from 'react';
import { Box, Button } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { Event } from 'xstate';

import { darkPurple } from 'utils/color-styles';
import { selectUser } from 'entities/user/selectors';
import getDeedFeatureForDeedType from 'utils/getDeedFeatureForDeedType';
import { DeedManagerPrivileges } from 'utils/privileges';
import { UserState } from 'entities/user/reducer';
import { truthy } from 'utils/truthy';

const hasAccess = (
  user: UserState,
  deedType: 'Campaign' | 'BaseEvent' | 'Event' | 'Project'
): boolean => {
  const cannotManageDeedType =
    user &&
    (!user.hasFeature(getDeedFeatureForDeedType(deedType)) ||
      !user.hasPrivilege(DeedManagerPrivileges[deedType]));
  return !cannotManageDeedType && !(deedType === 'Campaign' && !user?.canDonate());
};

export const Options = ({ send }: { send: (event: Event<any>) => void }): JSX.Element => {
  const user = useSelector(selectUser);

  const options = [
    hasAccess(user, 'Event') && {
      location: '/deeds/volunteer/edit/new',
      label: 'Organize a volunteer opportunity!',
    },
    hasAccess(user, 'Project') && {
      location: '/deeds/projects/edit/new',
      label: 'Recruit skills-based volunteers for a longer-term project!',
    },
    hasAccess(user, 'Campaign') && {
      location: '/deeds/campaigns/edit/new',
      label: 'Start a fundraiser to raise funds for an inspiring initiative!',
    },
  ].filter(truthy);
  return (
    <Box>
      {options.map((option, i) => (
        <Button
          key={option.location}
          style={{
            borderRadius: 4,
            marginBottom: i + 1 === options.length ? 0 : 8,
            color: darkPurple,
            borderColor: darkPurple,
            fontSize: 16,
          }}
          fullWidth
          onClick={(): unknown => send({ type: 'NAVIGATE', location: option.location })}
        >
          {option.label}
        </Button>
      ))}
    </Box>
  );
};
